import { fetchProvider } from './fetch.js';

const CartService = (token) => {
    const fetch = fetchProvider(token, 'autoshipment-checkout-front', '/loy/api/autoshipment/v1/');
    const getAutoshipmentArticles = async (cartArticles, siteDomain, language, deliveryCountry, deliveryRegion) => (await fetch.post('checkout/cart-offer', {
        siteDomain: siteDomain,
        language: language,
        cartArticles: cartArticles,
        deliveryCountry: deliveryCountry,
        deliveryRegion: deliveryRegion,
    })).responseBody;
    const getAutoshipmentDiscount = async (cartArticles, siteDomain) => (await fetch.post('checkout/autoshipment-discount', {
        siteDomain: siteDomain,
        cartArticles: cartArticles,
    })).responseBody;
    const getFODCapping = async (siteDomain) => (await fetch.get(`first-order-discount/capping?siteDomain=${siteDomain}`))
        .responseBody;
    return {
        getAutoshipmentArticles,
        getAutoshipmentDiscount,
        getFODCapping,
    };
};

export { CartService };
//# sourceMappingURL=CartService.js.map
